import Vue from "vue";
import Vuex from "vuex";
import Lockr from "lockr";
import _ from "lodash";
import moment from "moment-es6";
import jsonApi from "@/store/jsonapi.js";
import clientApi from "@/store/clientapi.js";
import Api from "@/store/jsonapi";
import axios from "axios";
import config from "@/config";

import BroadcastChannel from "broadcast-channel";
const channel = new BroadcastChannel("webshipper_auth", {
  webWorkerSupport: false,
});

Vue.use(Vuex);

function setCookie(val) {
  // Valid 1 day
  let root_domain = document.location.hostname.replace("backend", "");
  document.cookie =
    "backend_login=" + val + ";max-age=86400;path=/;domain=" + root_domain;
}

const store = new Vuex.Store({
  state: {
    token: null,
    refresh_token: null,
    staff: null,
    token_timestamp: null,
    breadcrumbs: [],
    currentTenant: null,
    currentOrganization: null,
    lastUsedFilter: null
  },
  getters: {
    isWhiteLabel(state) {
      return state.currentOrganization.is_managed;
    },
    lastUsedFilter(state) {
      return state.lastUsedFilter;
    }
  },
  mutations: {
    setBreadcrumbs(state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs;
    },
    setCurrentTenant(state, tenant) {
      state.currentTenant = tenant;
      clientApi.headers["Authorization"] = "Bearer " + tenant.token;
      clientApi.headers["X-TenantName"] = tenant.tenantName;
    },
    setToken(state, token) {
      Lockr.set("token", token);
      Lockr.set("authtimeout", moment().add(10, "minutes"));
      state.token = token;

      jsonApi.headers["Authorization"] = token;
      jsonApi.headers["X-TenantName"] = "backend";

      if (_.isEmpty(token)) {
        state.staff = null;

        setCookie("0");
      } else {
        Api.find("organizations", "current").then(({ data }) => {
          state.currentOrganization = data;

          if (!data.is_managed) {
            setCookie("1");
          }
        }).catch(() => {
          console.error("Could not fetch current organization");
        });
      }
    },
    setRefreshToken(state, refresh_token) {
      Lockr.set("refresh_token", refresh_token);
      state.refresh_token = refresh_token;
    },
    setStaff(state, staff) {
      Lockr.set("staff", staff);
      state.staff = staff;
    },
    setCurrentOrganization(state, organization) {
      state.currentOrganization = organization;
    },
    /**
     * Saves last used filter
     * @param {*} payload contains a filter as well as a url-path it is valid with.
     */
    setLastSavedFilter(state, payload) {
      const {filter, pathName} = payload;

      if (filter && pathName) {
        state.lastUsedFilter = { filter, pathName };
      } else {
        state.lastUsedFilter = null;
      }
    }
  },
  actions: {
    setTokenFromOtherTab({ commit, state }, payload) {
      commit("setToken", "Bearer " + payload.token);
      commit("setRefreshToken", payload.refresh_token);

      state.token_timestamp = payload.timestamp;
    },
    loadToken({ commit, state }) {
      let token = Lockr.get("token");
      if (token) {
        commit("setToken", token);
        commit("setStaff", Lockr.get("staff"));
      }

      let refresh_token = Lockr.get("refresh_token");
      if (refresh_token) {
        commit("setRefreshToken", refresh_token);
      }

      setInterval(async () => {
        const five_minutes_ago = new Date().getTime() - 5 * 60 * 1000;
        const latest_token = (
          state.token_timestamp || new Date(1970)
        ).getTime();

        if (latest_token > five_minutes_ago) {
          // Newer than 5 minutes
          // Just return as a newer token
          // has been set from another tab
          return;
        }

        if (!state.refresh_token) {
          return;
        }

        try {
          let { data } = await axios.post(
            config.api_endpoint + "/oauth/token",
            "grant_type=refresh_token&refresh_token=" + state.refresh_token,
            {
              headers: {
                "Content-Type":
                  "application/x-www-form-urlencoded; charset=UTF-8",
              },
            }
          );

          commit("setToken", "Bearer " + data.access_token);
          commit("setRefreshToken", data.refresh_token);

          channel.postMessage({
            token: data.access_token,
            refresh_token: data.refresh_token,
            timestamp: new Date(),
          });
        } catch (e) {
          console.error("error", e);
          this.error = e.response;
        }
      }, 1000 * 5 * 60); // 5 min
    },
  },
});

channel.onmessage = (payload) => {
  store.dispatch("setTokenFromOtherTab", payload);
};

export default store;
